import React from "react";
import AntdTooltip from 'antd/lib/tooltip';
import {withError} from '@fishx/tracker';

const Tooltip = (props) => <AntdTooltip {...props} />
Tooltip.displayName = 'Tooltip';
export default withError(Tooltip);



// WEBPACK FOOTER //
// ./src/components/tooltip/index.tsx